import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomSocketService extends Socket{

  constructor() {
    super({ url: environment.backendChatUrlPort, options: {
      query: {
        token: window.localStorage.getItem('chatToken')
      }
    } });
}
}
